import React, { useState, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import TestPaginationScriptButton from "./TestPaginationScriptButton";
import { setPaginationVariableScript } from "../utils/paginationUtil";
import { customTemplate } from "../utils/paginationTemplates";
import { setEditorSaved } from "../../../../../../../../redux/actions/integrationActions";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-dawn";
import { getAceEditorTheme } from "../../../../../../../../common/utils/aceEditorTheme";

const CustomPaginationEditor = ({ action }) => {
  const [value, setValue] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (action && action.pagination && action.pagination.variable && action.pagination.variable.script) {
      setValue(action.pagination.variable.script);
    } else {
      setValue(customTemplate(action?.pagination?.variable?.name));
    }
  }, [action?.id, action?.pagination?.type, action?.pagination?.variable?.script, action?.pagination?.variable?.name]);

  const scriptItem = useMemo(() => {
    const paginationVariable = action?.pagination?.variable;
    if (!paginationVariable) {
      return null;
    }
    return {
      ...paginationVariable,
      name: paginationVariable.name || "paginationResult",
      script: value,
    };
  }, [action, value]);

  const onChangeValue = (text) => {
    setValue(text);
    setPaginationVariableScript(action.pagination, text);
    dispatch(setEditorSaved(false));
  };
  return (
    <>
      <TestPaginationScriptButton action={action} scriptItem={scriptItem} appearance="subtle" />
      <AceEditor
        className="ihub-action-body-editor"
        mode="javascript"
        theme={getAceEditorTheme()}
        name="code"
        onChange={onChangeValue}
        editorProps={{ $blockScrolling: true }}
        value={value}
      />
    </>
  );
};

export default CustomPaginationEditor;
